import Card from 'react-bootstrap/Card';
import React, { FC, PropsWithChildren } from 'react';
import styles from './data-object-card.module.sass';

export const DataObjectCard: FC<PropsWithChildren> = (props) => {
    return <Card className={styles.dataObjectCard} id="dataObjectCard">
        {props.children}
    </Card>;
};
